import styled from "@emotion/styled";
import { InputProps } from "./Input";
import { getSize, isNot, matchProps, SizeName, Sizes } from "@mrocket/styles";
import { css } from "@emotion/react";
import { Text } from "../Text/Text";


const getIconSize = getSize({
  tiny: 'var(--sizeBase7)',
  small: 'var(--sizeBase6)',
  medium: 'var(--sizeBase8)',
  large: 'var(--sizeBase9)',
})
const getInputSize = getSize({
  tiny: 'var(--sizeBase8)',
  small: 'var(--sizeBase9)',
  medium: 'var(--sizeBase10)',
  large: 'var(--sizeBase11)',
})
const getTextSize = getSize({
  tiny: "14px",
  small: "15px",
  medium: "16px",
  large: "17px",
})
export const InputContainer = styled.div<InputProps>`
  width: ${props => props.width ? `${props.width}px` : '100%'};
`
export const InputText = styled(Text)`
  margin-bottom: var(--sizeBase2);
`
export const InputContent = styled('div')`
  display: flex;
  align-items: center;
`
console.log(getIconSize('medium'))

const matchRoot = matchProps<InputProps & { inputSize: InputProps['size'] }>()
export const InputRoot = styled('input', {
  shouldForwardProp: props => !['size', 'after', 'before', 'clear', 'inputSize'].includes(props)
})<InputProps & { inputSize: InputProps['size'] }>`
  outline: none;
  font-weight: 400;
  letter-spacing: -.022em;
  font-family: var(--fontFamilyBase);
  color: var(--colorText);
  border: none;
  width: 100%;
  text-indent: 10px;
  font-size: ${props => getTextSize(props.inputSize)};
  background: transparent;
  height: 100%;
  &::placeholder {
    color: var(--colorText4);
  }
`

export const InputLabel = styled.div<
  {
    ['data-focus']: boolean,
    appearance: InputProps['appearance'],
    size: SizeName
  }
>`
  position: relative;
  flex-grow: 1;
  display: flex;
  align-items: center;
  
  border-radius: var(--borderRadiusBase);
  overflow: hidden;
  transition: box-shadow 150ms ease;
  height: ${props => getInputSize(props.size)};
  
  .after,
  .before {
    display: flex;
    font-size: 0;
    height: 100%;
    align-items: center;
    > svg {
      width: ${props => getIconSize(props.size)};
      height: ${props => getIconSize(props.size)};
    }
  }
  .after {
    padding-right: 10px;
  }

  .before {
    padding-left: 6px;
  }
  
  ${isNot("appearance", css`
    background-color: var(--colorFill4Alpha);
   
    &[data-focus=true] {
      border-color: var(--colorBlue);
      box-shadow: inset 0 0 0 1px var(--colorBlue);
    }
  `)};
  ${matchRoot("appearance", "fill", css`
    background-color: var(--colorFill4Alpha);
    
    &[data-focus=true] {
      border-color: var(--colorBlue);
      box-shadow: inset 0 0 0 1px var(--colorBlue);
    }
  `)};
  ${matchRoot('appearance', 'plain', css`
    background-color: transparent;
   
  `)};
  ${matchRoot('appearance', 'overlay', css`
    background-color: transparent;
    
    &[data-focus=true] {
      border-color: var(--colorBlue);
      box-shadow: inset 0 0 0 1px var(--colorBlue);
    }
  `)};
  ${matchRoot('appearance', 'outline', css`
    background-color: transparent;
    border: 1px solid var(--colorFill4Alpha);
    &[data-focus=true] {
      border-color: var(--colorBlue);
      box-shadow: inset 0 0 0 1px var(--colorBlue);
    }
  `)};
`